// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuContent_menuItem__f6cf1","menuItemText":"MenuContent_menuItemText__4678a"};